import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import bikeTheftData from './data/bike-theft.json';
import bikeIconImg from './bike-icon.png'; // Import your custom icon

// Fix for default marker icons
delete L.Icon.Default.prototype._getIconUrl;

// Custom bike theft icon using your image
const bikeIcon = new L.Icon({
  iconUrl: bikeIconImg,
  iconSize: [48, 48],
  iconAnchor: [24, 24],
  popupAnchor: [0, -24],
});

const MapComponent = () => {
  const [bikeThefts, setBikeThefts] = useState([]);
  const [loading, setLoading] = useState(true);

  const copenhagenCenter = [55.6761, 12.5683];

  useEffect(() => {
    const loadData = async () => {
      try {
        setBikeThefts(bikeTheftData);
        setLoading(false);
      } catch (error) {
        console.error('Error loading bike theft data:', error);
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const formatDate = (dateStr) => {
    const [day, month, year] = dateStr.split('-');
    return `${day}/${month}/${year}`;
  };

  if (loading) {
    return <div style={{ padding: '20px' }}>Loading bike theft data...</div>;
  }

  return (
    <MapContainer
      center={copenhagenCenter}
      zoom={12}
      style={{ height: '100vh', width: '100%' }}
    >
      <TileLayer
        attribution='&copy; OpenStreetMap contributors, Tiles &copy; JFM'
        url="https://tiles.jfmtech.dk/styles/osm-bright/{z}/{x}/{y}.png"
      />
      
      <MarkerClusterGroup
        chunkedLoading
        maxClusterRadius={50}
        spiderfyOnMaxZoom={true}
        showCoverageOnHover={false}
        iconCreateFunction={(cluster) => {
          const count = cluster.getChildCount();
          let colorClass = 'small';
          
          if (count > 50) {
            colorClass = 'large';
          } else if (count > 10) {
            colorClass = 'medium';
          }
          
          return L.divIcon({
            html: `<div class="cluster-inner cluster-${colorClass}">${count}</div>`,
            className: 'marker-cluster-custom',
            iconSize: L.point(40, 40)
          });
        }}
      >
        {bikeThefts.map((theft, idx) => {
          const [lng, lat] = theft.coords;
          
          return (
            <Marker
              key={idx}
              position={[lat, lng]}
              icon={bikeIcon}
            >
              <Popup>
                <div style={{ minWidth: '200px' }}>
                  <h3 style={{ margin: '0 0 10px 0', fontSize: '16px', color: '#d32f2f' }}>
                    🚲 Cykel Tyveri
                  </h3>
                  <div style={{ fontSize: '14px' }}>
                    <p style={{ margin: '5px 0' }}>
                      <strong>Dato:</strong> {formatDate(theft['Anm. dato'])}
                    </p>
                    <p style={{ margin: '5px 0' }}>
                      <strong>Adresse:</strong> {theft.adresse_}
                    </p>
                    
                    <p style={{ margin: '5px 0' }}>
                      <strong>Type:</strong> {theft['G.sted type']}
                    </p>
                  </div>
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MarkerClusterGroup>
    </MapContainer>
  );
};

export default MapComponent;